export { default } from "bullitttime-embermodelsevent/models/course";
